var $6ec1ed7729e948cc$exports = {};
$6ec1ed7729e948cc$exports = {
  "breadcrumbs": "Popis cesty"
};
export { $6ec1ed7729e948cc$exports as default };